define("StoreLocator.Details.View.Extension", [
  "StoreLocator.Details.View",
  "underscore",
  "Ames.StoreLocator2.StoreLocator2.Model"
], function defineWizardView(StoreLocatorDetailsView, _, StoreLocator2Model) {
  "use strict";
  _.extend(StoreLocatorDetailsView.prototype, {
    initialize: _.wrap(
      StoreLocatorDetailsView.prototype.initialize,
      function (fn, options) {
        this.locatorModel = new StoreLocator2Model();
        var locationId = options.routerArguments[0];
        this.storeHours = '';
        var self = this;
        this.locatorModel
          .fetch({ data: { locationId: locationId } })
          .done(function (resp) {
            if (resp.storeHours) {
                self.storeHours = resp.storeHours.split(',');
                self.render();
            }
          });

        fn.apply(this, _.toArray(arguments).slice(1));
      }
    ),
    getContext: _.wrap(
      StoreLocatorDetailsView.prototype.getContext,
      function (fn) {
        var context = fn.apply(this, _.toArray(arguments).slice(1));
        this.storeHours = this.storeHours || '';
        if (this.storeHours) {
          context.storeHours = this.storeHours;
        }
        return context;
      }
    ),
  });
});
